import dayjs from 'dayjs';

// eventDate is a date-only LocalDate; formatting it must not convert timezones.
export function formatEventDate(eventDate: string | undefined): string {
  if (!eventDate?.trim()) return '';

  return dayjs.tz(eventDate).format('MMMM D, YYYY');
}
